import { Inject, Injectable } from '@angular/core';
import { map, retry, share, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG } from '@boma/app-config';
import { BehaviorSubject, from, Observable } from 'rxjs';
import { LoggingService } from '@boma/supplier-portal/shared/services';
import { getToken, Messaging, onMessage } from '@angular/fire/messaging';
import firebase from "firebase";
import MessagePayload = firebase.messaging.MessagePayload;

@Injectable()
export class FirebaseNotificationsService {
  private base: string;
  private version: string;
  private ready = new BehaviorSubject(false);
  messages$ = new Observable((sub) =>
    onMessage(this.afMessaging, (it) => sub.next(it))
  ).pipe(map((payload: MessagePayload) => payload));

  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private http: HttpClient,
    private afMessaging: Messaging,
    private loggingService: LoggingService
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
    from(
      navigator.serviceWorker
        .register('/firebase-messaging-sw.js', {
          type: 'module',
          scope: '__',
        })
        .then((serviceWorkerRegistration) =>
          getToken(this.afMessaging, {
            serviceWorkerRegistration,
          })
        )
    ).pipe(
      tap((token) => {
        this.loggingService.logDebug('Found a token', token);
        if (token)
          this._updateMessagingToken(token)
            .pipe(retry(3))
            .subscribe(() => this.ready.next(true));
      }),
      share()
    );
  }

  private _updateMessagingToken(token: string) {
    return this.http.post(
      `${this.base}api/v${this.version}/Notifications/DeviceRegistration/${token}`,
      {
        deviceType: 'Browser',
      }
    );
  }
}
